import React, { useState } from 'react'
import { FaCalendarCheck } from "@react-icons/all-files/fa/FaCalendarCheck";
import { FaFileInvoiceDollar } from "@react-icons/all-files/fa/FaFileInvoiceDollar";
import { FaShoppingCart } from "@react-icons/all-files/fa/FaShoppingCart";
import { BsArrowRight } from "@react-icons/all-files/bs/BsArrowRight";
import { BiAddToQueue } from "@react-icons/all-files/bi/BiAddToQueue";
import { AiOutlineUserAdd } from "@react-icons/all-files/ai/AiOutlineUserAdd";
import { useDispatch, useSelector } from 'react-redux';
import {  getWorkingPackages } from '../store/slices/entities/packages';
const StepProc = ({ production, long, step  }) => {
       let packages = useSelector(getWorkingPackages)
        let setup_time = packages?.reduce((a,b) => a+ (b.setup_time || 0), 0)

    return <div className={`stepProc ${long ? 'long':''}`}   >
        <div className={`col ${step && step < 1 ? 'pending' : ''}`}>
            <FaCalendarCheck />
            <span className='name'>Select {production ? 'Time & Place' :'Dates'}</span>
        </div>  
        <BsArrowRight className={`arrow ${step && step < 2 ? 'pending' : ''}`} />
        {long && <>
            <div className={`col ${step && step < 2 ? 'pending' : ''}`}>
            <BiAddToQueue />
            <span className='name'> Select AV Equipment</span>
     </div>  
         {setup_time >2 && <>   <BsArrowRight className={`arrow ${step && step < 3 ? 'pending' : ''}`} />
        <div className={`col ${step && step < 3 ? 'pending' : ''}`}>
            <AiOutlineUserAdd />
            <span className='name'> Prod. Times & Labor</span>
        </div> 
        </> }
        <BsArrowRight className={`arrow ${step && step < 4 ? 'pending' : ''}`} />
        </>}
        <div className={`col ${step && step < 4 ? 'pending' : ''}`}>
            <FaFileInvoiceDollar />
            <span className='name'>{production ? 'Get a Final Price' : 'Review your Order'}</span>
        </div>  
        <BsArrowRight className={`arrow ${step && step < 4 ? 'pending' : ''}`} />
   
        <div className={`col ${step && step < 5 ? 'pending' : ''}`}>
            <FaShoppingCart />
            <span className='name'>Book Online</span>
        </div>  

    </div>
}

export default StepProc